import { Component, viewChild } from '@angular/core';
import { WindowComponent } from 'movisat-common-gui';
import { PluginCardComponent } from './plugin-card/plugin-card.component';
import { AppComponent } from 'src/app/app.component';
import { PluginsManager } from 'src/app/managers/plugins.manager';
import { IPlugin } from 'src/app/interfaces/IPlugin';

@Component({
  selector: 'app-plugins-dialog',
  standalone: true,
  imports: [
    WindowComponent,
    PluginCardComponent
  ],
  templateUrl: './plugins-dialog.component.html',
  styleUrl: './plugins-dialog.component.css',
})
export class PluginsDialogComponent {
  public pluginsWindow = viewChild<WindowComponent>('pluginsWindow');
  public static _this: PluginsDialogComponent;

  public constructor(
    private pluginsManager: PluginsManager
  ) {}

  public getPlugins(): IPlugin[] {
    return this.pluginsManager.getAllPlugins();
  }

  protected translate(text: string): string {
    return AppComponent.translate(text);
  }
 }
